import React, { Component, memo } from "react";
import KickImage from 'Reuseables/KickImage';
import { connect } from "react-redux";
import {
  Row,
  Col,
  Container,
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Button
} from "reactstrap";
import classNames from "classnames";

import Thumbnails from "../../PageProductDetails/Detail/Thumbnails";
import { TextRupiah } from "../../Text";

import {
  getImageBanner,
  getCollectionAllCategory
} from "../../../actions/kafairAction";

import { normalizeBrand } from "../../../utils/Helpers";
import { getCloudImageUrl, emptyImage } from "../../../utils";

import FanImg from "../../../images/kipas.png";
import emptySneakerImg from "../../../images/emptysneakers2.png";
import emptyApparelImg from "../../../images/emptyapparels.png";
import emptyHandbagImg from "../../../images/emptyhandbags.png";

import styled from "styled-components";

// IMPORT ARROW
import Merchandise_Arrow_Next from "../../../images/arrow/mer_n.png"
import Merchandise_Arrow_Prev from "../../../images/arrow/mer_p.png"

function NextArrow(props) {
  const { className, style, onClick } = props
  const RightArrow = styled.div`
    &::before {
    content: "" !important;
    }
  `
  return (
    <RightArrow
      className={className}
      style={{ ...style, display: "block" }}
      onClick={onClick}
    >
      <KickImage src={Merchandise_Arrow_Next} alt="..." className="slider-arrow arrow-right" />
    </RightArrow>
  )
}

function PreviousArrow(props) {
  const { className, style, onClick } = props
  const LeftArrrow = styled.div`
    &::before {
    content: "" !important;
    }
  `
  return (
    <LeftArrrow
      className={className}
      style={{ ...style, display: "block" }}
      onClick={onClick}
    >
      <KickImage src={Merchandise_Arrow_Prev} alt="..." className="slider-arrow arrow-left" />
    </LeftArrrow>
  )
}

const previewSettings = {
  arrows: true,
  // autoplay:true,
  infinite: false,
  speed: 500,
  slidesToShow: 5,
  slidesToScroll: 5,
  lazyLoad: true,
  dots: false,
  swipe: false,
  nextArrow: <NextArrow />,
  prevArrow: <PreviousArrow />,
  responsive: [
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ],
};

const FilterButton = memo(({ item, filterProductList, isActive }) => {
  return (
    <Button
      style={{ backgroundColor: "transparent" }}
      className="filter-price"
      onClick={() => filterProductList(isActive ? "" : item.name, item)}
    >
      <p>{item.text}</p>
    </Button>
  );
});

const ProductItem = ({ item, index, resultTickets }) => {
  return (
    <div key={index} className="sneaker-item">
      <div
        className={classNames("product-card official", {
          disabled: !item.price || item.out_of_stock
        })}
      >
        <a href={`/${item.category}/${item.id}/${item.slug}`}>
          <div
            className={classNames("sneaker-item__text", {
              disabled: !item.price || item.out_of_stock
            })}
          >
            <p>{item.brand ? normalizeBrand(item.brand) : null}</p>
            <p>{item.display_name}</p>
          </div>
          <KickImage
            alt={item.display_name}
            src={item.img}
            className={classNames("sneaker-item__image", {
              disabled: !item.price || item.out_of_stock
            })}
          />
          {item.price ? (
            <div style={{ textAlign: "center" }}>
              <TextRupiah
                value={item.price}
                className="price-tag"
                color="black"
                bold={true}
                align="center"
              />
              <div style={{ marginTop: 3, textAlign: "center" }}>
                {!!resultTickets && resultTickets.length > 0 && (
                  <span className="text-center">
                    Get
                    {resultTickets.length > 0 &&
                      resultTickets.map((item, index) => (
                        <span
                          className={classNames(
                            "text-center",
                            { red: item.includes("RED") },
                            { purple: item.includes("PURPLE") },
                            { gold: item.includes("GOLD") }
                          )}
                        >
                          {" "}
                          {item.toLowerCase()}
                          {"\n"}
                          <span className="text-center">
                            {resultTickets.length === index + 1 ? "" : "+"}
                          </span>
                        </span>
                      ))}
                  </span>
                )}
              </div>
            </div>
          ) : (
            <div style={{ textAlign: "center" }}>
              <span className="text-center">X</span>
            </div>
          )}
        </a>
      </div>
    </div>
  );
};

class OfficialMerchandise extends Component {
  constructor(props) {
    super(props);
    this.state = {
      category: "sneakers",
      page: 1,
    };
  }

  componentDidMount() {
    const payloadProducts = {
      collection: "official-merchandise",
      collection_type: "product_variants",
      page: 1,
      per_page: 30,
      pre_verified: true
    };

    this.props.getImageBanner(
      "official-merchandise",
      "official_merchandise",
      "bcaxkickavenue"
    );
    this.props.getCollectionAllCategory(
      payloadProducts,
      "official_merchandise"
    );
  }

  goToProductList = slug => {
    this.props.history.push(`/bcaxkickavenue/${slug}`);
  };

  _getTickets = sku => {
    // const str = "TPH001-RED1/PURPLE50/GOLD20"; //kalo mau test pake ini
    const str = sku;
    const words = str.split("-");
    const output = [];

    if (words && words.length > 1) {
      const allocation = words[1].split("/");

      allocation.map(item => {
        output.push({
          color: item.replace(/[0-9]/g, "", ""),
          number: item.replace(/[^\d.-]/g, "", "")
        });
      });
    }

    return output;
  };

  renderProducts = () => {
    const {
      data: {
        products: { data }
      }
    } = this.props;

    return (
      <div>
        <div className="d-none d-sm-block">
          {data.length > 3 ? (
            <Thumbnails
              settings={previewSettings}
              afterChange={this.changeImage}
              beforeChange={this._handleBeforeChange}
              thumbnails={data.map(item => {
                const category = item.product.category.name;
                return {
                  id: item.id,
                  slug: item.slug,
                  img: item.product_variant_images.length
                    ? getCloudImageUrl(item.product_variant_images[0].URL, 400)
                    : emptyImage(category),
                  display_name: item.display_name,
                  brand:
                    item.product &&
                    item.product.brand &&
                    item.product.brand.flat[0],
                  price: item.price,
                  out_of_stock: item.out_of_stock,
                  category,
                  sku: item.SKU
                };
              })}
              active={this.state.currentIndex}
              renderItems={data => this._renderItems(data)}
            />
          ) : (
            <Row className="product-row">
              {data.length > 0 && data.length > 1
                ? data.map((datas, index) => {
                  const category = datas.product.category.name;
                  const tickets = this._getTickets(datas.SKU);
                  const resultTickets =
                    tickets.length > 0
                      ? tickets
                        .filter(item => item.number != 0)
                        .map(
                          item =>
                            `${item.number}${" "}${item.color}${" Tickets"}`
                        )
                      : null;

                  const item = {
                    id: datas.id,
                    slug: datas.slug,
                    img: datas.product_variant_images.length
                      ? getCloudImageUrl(
                        datas.product_variant_images[0].URL,
                        400
                      )
                      : emptyImage(category),
                    display_name: datas.display_name,
                    brand:
                      datas.product &&
                      datas.product.brand &&
                      datas.product.brand.flat[0],
                    price: datas.price,
                    out_of_stock: datas.out_of_stock,
                    category:
                      category === "apparels" ? "apparel" : category,
                    sku: datas.SKU
                  };
                  return (
                    <Col md={3} style={{ maxWidth: "18%" }}>
                      <ProductItem
                        item={item}
                        index={index}
                        resultTickets={resultTickets}
                      />
                    </Col>
                  );
                })
                : null}
            </Row>
          )}
        </div>
        <div className="d-block d-sm-none">
          {data.length > 0 ? (
            <Thumbnails
              settings={previewSettings}
              afterChange={this.changeImage}
              beforeChange={this._handleBeforeChange}
              lengthShow={1}
              thumbnails={data.map(item => {
                const category = item.product.category.name;
                return {
                  id: item.id,
                  slug: item.slug,
                  img: item.product_variant_images.length
                    ? getCloudImageUrl(item.product_variant_images[0].URL, 400)
                    : emptyImage(category),
                  display_name: item.display_name,
                  brand:
                    item.product &&
                    item.product.brand &&
                    item.product.brand.flat[0],
                  price: item.price,
                  out_of_stock: item.out_of_stock,
                  category,
                  sku: item.SKU
                };
              })}
              active={this.state.currentIndex}
              renderItems={data => this._renderItems(data)}
            />
          ) : null}
        </div>
      </div>
    );
  };

  _renderItems(data) {
    return data.map((item, index) => {
      const category =
        item.category === "apparels" ? "apparel" : item.category;
      const tickets = this._getTickets(item.sku);
      const resultTickets =
        tickets.length > 0
          ? tickets
            .filter(item => item.number != 0)
            .map(item => `${item.number}${" "}${item.color}${" Tickets"}`)
          : null;
      return (
        <div key={index} className="sneaker-item">
          <div
            className={classNames("product-card official", {
              disabled: !item.price || item.out_of_stock
            })}
          >
            <a href={`/${category}/${item.id}/${item.slug}`}>
              <div
                className={classNames("sneaker-item__text", {
                  disabled: !item.price || item.out_of_stock
                })}
              >
                <p>{item.brand ? normalizeBrand(item.brand) : null}</p>
                <p>{item.display_name}</p>
              </div>
              <KickImage
                alt={item.display_name}
                src={item.img}
                className={classNames("sneaker-item__image", {
                  disabled: !item.price || item.out_of_stock
                })}
              />
              {item.price ? (
                <div style={{ textAlign: "center" }}>
                  <TextRupiah
                    value={item.price}
                    className="price-tag"
                    color="black"
                    bold={true}
                    align="center"
                  />
                  <div style={{ marginTop: 3, textAlign: "center" }}>
                    {!!resultTickets && resultTickets.length > 0 && (
                      <span className="text-center">
                        Get
                        {resultTickets.length > 0 &&
                          resultTickets.map((item, index) => (
                            <span
                              className={classNames(
                                "text-center",
                                { red: item.includes("RED") },
                                { purple: item.includes("PURPLE") },
                                { gold: item.includes("GOLD") }
                              )}
                            >
                              {" "}
                              {item.toLowerCase()}
                              {"\n"}
                              <span className="text-center">
                                {resultTickets.length === index + 1 ? "" : "+"}
                              </span>
                            </span>
                          ))}
                      </span>
                    )}
                  </div>
                </div>
              ) : (
                <div style={{ textAlign: "center" }}>
                  <span className="text-center">X</span>
                </div>
              )}
            </a>
          </div>
        </div>
      );
    });
  }

  render() {
    const { category } = this.state;
    const {
      data: {
        title,
        isActive,
        description,
        kafair: { imagesLandscape }
      }
    } = this.props;

    return (
      <Container fluid className="special-deals-section official novembazar">
        <Row
          className="content-container made-in-indonesia"
          style={{ backgroundImage: `url(${this.props.background})`, backgroundSize: "cover", marginTop: "50px" }}
        >
          <Col md={12} xs={12}>
            <div className="header-wrapper">
              <div style={{ position: "relative" }}>
                <KickImage alt={`${this.props.title} Category`} src={this.props.header} className="title-img" />
              </div>
              <div className="title-wrapper">
                <p style={{ color: 'white', cursor: "pointer", fontStyle: "italic" }} onClick={() => this.goToProductList("official-merchandise")}>Show All</p>
              </div>
            </div>
          </Col>
          <Col md={12} xs={12}>
            <div className="right-side local-brands official category" style={{ marginTop: "20px" }}>
              {this.renderProducts()}
            </div>
          </Col>
        </Row>
      </Container>
    );
  }
}

const mapStateToProps = state => ({
  data: state.dataKaFair.official_merchandise
});

const mapDispatchToProps = dispatch => ({
  getImageBanner: (slug, name, category) =>
    dispatch(getImageBanner(slug, name, category)),
  getCollectionAllCategory: (payload, name) =>
    dispatch(getCollectionAllCategory(payload, name))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(OfficialMerchandise);
